import Megatron from '@stencil/megatron';
import {HotelsPaymentsInput} from './types';
import roomStringUtils from '@stencil/hotels-utils/src/room-string-utils';
import {noOfNights} from '@stencil/hotels-utils/src/common-utils';
import dateFormat from 'dateformat';
import querystring from 'query-string';
import {appConfig} from '@stencil/hotels-config';

export function prepareHotelsPaymentsUrl(flavour) {
  let flavourQuery = (!!flavour && `?flavour=${flavour}`) || '';
  return `/hotels/payment/${flavourQuery}`;
}

export const hotelsPaymentsApi = async ({
  checkin,
  checkout,
  useGoCash,
  descblockResponse,
  descblockInput,
  travellerInfo,
  userInfo,
  earlycheckin,
  flavour = '',
  donateCharity = false,
}: HotelsPaymentsInput) => {
  const {hc, rtc, rpc, fwdParams, pay_mode: pm, v, strQry, paxString} = descblockInput;

  const ci = dateFormat(checkin, 'yyyymmdd');
  const co = dateFormat(checkout, 'yyyymmdd');

  const {childrenCount, adultCount, roomConfig} = roomStringUtils.getRoomConfig(paxString);

  const {
    cdata,
    promocode = '',
    paas_pay_modes = {},
    paas_pay_modes_v2 = false,
    udf1,
  } = descblockResponse;

  const {
    aftrpromototal,
    destination,
    HotelAddress,
    HotelName,
    gohtlid,
    checkin_display,
    checkout_display,
    city,
    country,
    Image,
    location,
    HotelRating,
    checkintime,
    max_gocash = 0,
    non_vested_gocash = 0,
    vested_gocash = 0,
    personalized_keys,
    pay_mode,
    payment_type,
    is_domestic,
    dispPromoBox,
    credits,
    total_credits = 0,
    vested_credits = 0,
    non_vested_credits = 0,
    is_pah,
    RoomTypeName,
    addon_list = [],
    additional_options = [],
  } = cdata;
  const [expected_checkin_time = appConfig.defaultCheckinTime] = checkintime.split(' ');
  const strQuery = strQry ? strQry.split('-') : [];
  const vcid = strQuery[1] || '';
  let charityPrice = 0;
  if (additional_options.length) {
    const {sell_price = 0} = additional_options[0];
    charityPrice = sell_price;
  }
  const qryDict = {
    user_latitude: '',
    user_longitude: '',
    vo: '',
    rpco: '',
    rtco: '',
    destination,
    fwdParams,
    vertical: 'hotels',
    checkin: ci,
    HotelAddress,
    noOfNights: noOfNights(checkout, checkin),
    HotelName,
    code: promocode.toUpperCase(),
    rooms: roomConfig.map(item => ({adults: item.adult, childs: item.childArray || []})),
    country_code: cdata.country_code,
    hc,
    voyagerid: vcid,
    gohtlid,
    checkin_display,
    city,
    rtc,
    noofAdults: adultCount,
    country,
    Image,
    checkout_display,
    rpc,
    newui: 'True',
    chkoutdate: co,
    noofChildren: childrenCount,
    location,
    strQry,
    v,
    chkindate: ci,
    noofRooms: roomConfig.length,
    checkout: co,
    HotelRating,
  };

  const {nameDetails, businessProfile = false, selectedCheckinTime} = travellerInfo;

  const bookingData = {...cdata, paas_pay_modes_v2};
  // const {cn, sn, mail, country_code, mobileno} = userInfo;
  let paymentData = {
    vertical: 'hotels',
    productid: hc,
    voyagerid: hc,
    gohtlid: gohtlid || hc,
    qryDict: JSON.stringify(qryDict),
    bookingdata: JSON.stringify(bookingData),
    querydata: strQry,
    guest: 'guest',
    hiddenPrice: aftrpromototal,
    leadcodelist: '[]',
    code: promocode,
    amountCr: udf1,
    hiddenudf4: '',
    hiddenudf5: '',
    avoiddupe: '',
    fwdParams,
    internationalhotels: is_domestic === 1 ? 'False' : 'True',
    cityid: vcid,
    cityname: city || '',
    newui: 'True',
    dispPromoBox,
    partner: 'goibibo',
    actualamount: '',
    actualcredits: 0,
    paytype: 'goCashCards',
    totfare: aftrpromototal,
    cr_prod_name: 'gi.hotels.trip',
    otp: '',
    gocashpromocode: '',
    choose: nameDetails[0].nameTitle,
    email: travellerInfo.email,
    country_code: travellerInfo.countryCode,
    mobile: travellerInfo.phoneNumber,
    expected_checkin_time: selectedCheckinTime || expected_checkin_time,

    special_requests: '',
    firstname: nameDetails[0].firstName,
    lastname: nameDetails[0].lastName,
    address:
      'ibibo Web Private Limited, 5 th Floor, Good Earth City Centre,Sector 50,Gurgaon,Haryana - 122018.',
    city: city || '',
    pincode: '122002',
    state: 'Delhi',
    country: country || '',
    landline: '',
    credits: credits || '',
    payuId: '',
    password: '',
    total_credits,
    vested_credits,
    non_vested_credits,
    credits_amount: useGoCash ? max_gocash : 0, // revisit
    charity_amount: donateCharity && charityPrice ? charityPrice : 0,
    non_vested_gocash,
    vested_gocash,
    native_pay_amnt:
      (personalized_keys.np_wt !== undefined ? personalized_keys.np_wt : aftrpromototal) || 0,
    vertical_redmp: 0,
    go_pn: 1,
    go_pg: is_pah === 0 ? 'payu' : 'adyen',
    pay_mode: pay_mode || pm,
    payment_type,
    is_domestic,
    type: businessProfile ? 'business' : 'personal', // revisit
    pay_gst_number: travellerInfo.gstNumber || '',
    pay_gst_company_name: travellerInfo.companyName || '',
    pay_gst_business_email: travellerInfo.businessEmail || '',
    pay_gst_company_address: travellerInfo.companyAddress || '',
    pay_gst_phone_number: travellerInfo.companyPhone || '',
    gst_business_country: '',
    gst_business_state: '',
    customer_pan_no: travellerInfo.travellersPan || undefined,
    passPayModes: JSON.stringify(paas_pay_modes),
    paas_pay_modes_v2,
    addon_list: earlycheckin ? JSON.stringify(addon_list) : '',
  };

  let namesData = {};
  nameDetails.forEach(({nameTitle, firstName, lastName}, index: number) => {
    namesData = {
      ...namesData,
      [`firstname${index + 1}`]: firstName,
      [`lastname${index + 1}`]: lastName,
      [`choose${index + 1}`]: nameTitle,
    };
  });

  paymentData = {...paymentData, ...namesData};

  const __payments__ = prepareHotelsPaymentsUrl(flavour); // have to be shifted to config package
  const url = `${__payments__}`;
  const data = querystring.stringify(paymentData);
  const response = await Megatron({
    name: 'hotel payments api',
    type: 'POST',
    url,
    requestData: data,
    credentials: 'include',
    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
  });

  return response;
};
export default hotelsPaymentsApi;
